import { TFunction } from 'i18next';
import React from 'react';
import CloseButton from 'react-bootstrap/CloseButton';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';

import StockCodeInput from '../../form/StockCodeInput';

interface Props {
  show: boolean;
  handleClose: () => void;
  handleComparisonStockList: (stock: string) => void;
  comparisonStockNames: string[];
  handelDeleteComparisonPrice: (index: number) => void;
  t: TFunction;
  stockInput: string;
  handleStockInput: (stock: string) => void;
}
const comparisonSearch: React.FC<Props> = ({
  show,
  handleClose,
  handleComparisonStockList,
  comparisonStockNames,
  handelDeleteComparisonPrice,
  t,
  stockInput,
  handleStockInput,
}) => {
  const search = (stockCode: string) => {
    if (comparisonStockNames.length < 2) {
      handleComparisonStockList(stockCode);
    }
    handleClose();
  };

  const handleSearch = (e, focus = false, stockName?: string) => {
    e.preventDefault();
    if (focus) {
      const stockInput =
        document.querySelector<HTMLInputElement>('.stock-input');
      stockInput.focus();
      stockInput.select();
    }
    if (!stockInput && !stockName) return;
    const theStockCode = stockName
      ? stockName.toUpperCase()
      : stockInput.toUpperCase();
    search(theStockCode);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {t('comparisonStock')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StockCodeInput
            value={stockInput}
            onChange={e => handleStockInput(e)}
            onKeyPress={e => {
              stockInput !== '' &&
                (e.keyCode || e.which) === 13 &&
                handleSearch(e, true);
            }}
            onSelected={search}
          />
          <p></p>
          <ListGroup>
            {comparisonStockNames.map((stockName, index) => (
              <ListGroup.Item
                action
                variant="light"
                key={index}
                onClick={() => handelDeleteComparisonPrice(index)}
              >
                {stockName}
                <CloseButton />
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default comparisonSearch;
